import React, { Component } from "react";
import {Card, Form, Button, Row, Col, Alert, Tab, Tabs} from "react-bootstrap";
import api from "../../services/api";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { formatarValor, formatarValorAPI, regrasPlanos } from '../../common/utils';
import { withRouter } from '../../common/with-router';
import AsyncSelect from 'react-select/async';
import { FaArrowDown, FaArrowUp, FaCheck, FaTimes, FaStream, FaEye } from "react-icons/fa";

class CarteirasEdit extends Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);

        this.enviaRegistro = this.enviaRegistro.bind(this);

        this.fileInput = React.createRef();

        this.state = {
            nome: '',
            status: true,
            erroLoadRegistro: "",
            carteira_id: "",
            titulo_pagina: "",
            loading: false,
            programas: [{ programa_id: '', programa_nome: '', id: null }],
            operadores: [{ operador_id: '', operador_nome: '', id: null }],
            gestores: [{ gestor_id: '', gestor_nome: '', id: null }],
        };
    }

    componentDidMount(){
        const id = this.props.router.params.id;

        this.setState({
            carteira_id: id,
            loading: true,
            erroLoadRegistro: ''
        })

        if(id){
            //consulta os dados do programa na api
            api.get(`/carteiras/${id}`)
            .then(response => {
                const dados = response.data;

                //preenche os inputs
                this.setState({
                    erroLoadRegistro: '',
                    nome: dados.nome,
                    status: dados.status,
                    loading: false,
                    titulo_pagina: 'Editando Carteira: ' + dados.nome,
                })
                
                this.carregarProgramasCarteira();
                this.carregarOperadoresCarteira();
                //this.carregarGestoresCarteira();
            })
            .catch(error => {
                let erro_msg = 'Erro ao consultar carteira, tente novamente';

                if(error.response && error.response.status === 500){
                    erro_msg = 'Servidor indisponível no momento, tente novamente';
                }

                this.setState({
                    erroLoadRegistro: erro_msg,
                })
            });
        }
        else {
            this.setState({
                carteira_id: '',
                titulo_pagina: 'Adicionar Carteira',
                loading: false,
                erroLoadRegistro: '',
            })
        }
    }

    enviaRegistro = (e) => {
        e.preventDefault();

        const formData = new FormData();

        this.setState({
            loading: true,
            nomeHelper: "",
            statusHelper: "",
        });

        //vererifica se é edição ou adição
        const url = (this.state.carteira_id) ? '/carteiras/'+this.state.carteira_id+'/' : '/carteiras/'
        const metodo = (this.state.carteira_id) ? 'put' : 'post'

        formData.append('nome', this.state.nome);
        formData.append('status', this.state.status);

        //envia para api
        api({
            method: metodo,
            url: url,
            data: formData,
        })
        .then(response => {
            const MySwal = withReactContent(Swal)
            const textSwal = (this.state.carteira_id) ? 'Carteira atualizada com sucesso' : 'Carteira cadastrada com sucesso';

            MySwal.fire({
                title: <p>{textSwal}</p>,
                icon: 'success',
                showCloseButton: true,
            })
            
            this.setState({
                loading: false,
            })
            
            //redireciona
            if(!this.state.carteira_id){
                this.props.router.navigate("/carteiras");
            }
        })
        .catch(error => {
            let erro_msg = 'Erro ao cadastrar a carteira, verifique os campos e tente novamente';            

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response && error.response.status === 400){
                const campos = error.response.data;                
                
                //percorre os campos com erro
                for (let key in campos){
                    var value = campos[key];

                    if(key === 'nome'){
                        this.setState({ nomeHelper: value })
                    }
                };
            }

            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>{erro_msg}</p>,
            })    
            
            this.setState({
                loading: false,
            })
        });
    };

    carregarProgramas = async (inputValue) => {
        if (inputValue.length < 3) return [];
        try {
            const response = await api.get(`/programas/?nome=${inputValue}`);
            const opcoes = response.data.results.map(programa => ({
                value: programa.id,
                label: programa.nome
            }));
            //this.setState({ opcoesClientes: opcoes });
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar programas:', error);
            return [];
        }
    };

    handleChange = (event, fieldName) => {
        const { name, value } = event.target;
        this.setState({ [name]: value });
    };

    carregarOperadores = async (inputValue) => {
        if (inputValue.length < 3) return [];
        try {
            const response = await api.get(`/pessoas/operadores/?nome=${inputValue}`);
            const opcoes = response.data.results.map(operador => ({
                value: operador.id,
                label: operador.dados_pessoa.nome
            }));
            //this.setState({ opcoesClientes: opcoes });
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar operadores:', error);
            return [];
        }
    };

    carregarGestores = async (inputValue) => {
        if (inputValue.length < 3) return [];
        try {
            const response = await api.get(`/pessoas/gestores/?nome=${inputValue}`);
            const opcoes = response.data.results.map(gestor => ({
                value: gestor.id,
                label: gestor.dados_pessoa.nome
            }));
            //this.setState({ opcoesClientes: opcoes });
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar operadores:', error);
            return [];
        }
    };

    //PROGRAMAS DA CARTEIRA
    carregarProgramasCarteira = () => {
        if (this.state.carteira_id) {
            api.get(`/carteiras/programas/?carteira=${this.state.carteira_id}`)
                .then(response => {
                    const programasCarregados = response.data.results.map(programa => ({
                        id: programa.id,
                        programa_id: programa.programa_id,
                        programa_nome: programa.dados_programa.nome
                    }));
                    this.setState({ programas: programasCarregados });
                })
                .catch(error => {
                    console.error('Erro ao carregar programas:', error);
                    
                    let erro_msg = 'Erro ao carregar programas da carteira, tente novamente';

                    if(error.response && error.response.status === 500){
                        erro_msg = 'Servidor indisponível no momento, tente novamente';
                    }

                    this.setState({
                        erroLoadRegistro: erro_msg,
                    })
                });
        }
    };

    salvarPrograma = (index) => {
        const programa = this.state.programas[index];
        const url = programa.id ? `/carteiras/programas/${programa.id}/` : '/carteiras/programas/';
        const metodo = programa.id ? 'put' : 'post';
    
        const dadosPrograma = {
            carteira_id: this.state.carteira_id,
            programa_id: programa.programa_id
        };

        api({
            method: metodo,
            url: url,
            data: dadosPrograma,
        })
        .then(response => {
            // Se for um novo programa, atualize o estado com a ID retornada pela API
            if (!programa.id) {
                this.setState(prevState => {
                    const programasAtualizados = [...prevState.programas];
                    programasAtualizados[index].id = response.data.id;
                    return { programas: programasAtualizados };
                });
            }
            
            const MySwal = withReactContent(Swal)
            const textSwal = (programa.id) ? 'Programa atualizado com sucesso' : 'Programa cadastrado com sucesso';

            MySwal.fire({
                title: <p>{textSwal}</p>,
                icon: 'success',
                showCloseButton: true,
            })
            
        })
        .catch(error => {
            let erro_msg = 'Erro ao cadastrar o programa, verifique os campos e tente novamente';       
            let content = '';     

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response && error.response.status === 400){
                const campos = error.response.data;                
                
                //percorre os campos com erro
                for (let key in campos){
                    var value = campos[key];

                    if(key == 'programa_id') {
                        content += `<br>&bull; Programa: ${value}`;
                    }
                };
            }

            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>{erro_msg}</p>,
                html: content,
            })
        });
    };

    adicionarPrograma = () => {
        this.setState(prevState => ({
            programas: [...prevState.programas, { programa_id: '', programa_nome: '' }],
        }));
    };

    removerPrograma = (index) => {
        const MySwal = withReactContent(Swal);
    
        MySwal.fire({
            title: 'Remover programa?',
            text: "Tem certeza que deseja remover este programa?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, remover!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {

                const programa = this.state.programas[index];

                if (programa.id) {

                    const url = `/carteiras/programas/${programa.id}/`;
                    const metodo = 'put';
                
                    const dadosPrograma = {
                        status: false
                    };
                
                    api({
                        method: metodo,
                        url: url,
                        data: dadosPrograma,
                    })
                    .then(response => {
                                              
                        const MySwal = withReactContent(Swal)
                        const textSwal = 'Programa removido com sucesso';

                        MySwal.fire({
                            title: <p>{textSwal}</p>,
                            icon: 'success',
                            showCloseButton: true,
                        })

                        this.setState(prevState => ({
                            programas: prevState.programas.filter((_, i) => i !== index),
                        }));
                        
                    })
                    .catch(error => {
                        let erro_msg = 'Erro ao remover o programa, tente novamente';            

                        if(error.response && error.response.status === 500){
                            erro_msg = 'Servidor indisponível no momento';
                        }
                        else if(error.response && error.response.status === 400){
                            const campos = error.response.data;       
                            
                        }

                        const MySwal = withReactContent(Swal)
                        MySwal.fire({
                            icon: 'error',
                            showCloseButton: true,
                            title: <p>{erro_msg}</p>,
                        })
                    });

                } else {
                    this.setState(prevState => ({
                        programas: prevState.programas.filter((_, i) => i !== index),
                    }));
        
                    MySwal.fire(
                        'Removido!',
                        'O programa foi removido.',
                        'success'
                    );
                }
            }
        });
    };

    handleProgramaChange = (index, event, fieldName) => {
        const programas = [...this.state.programas];
        if (fieldName === 'programa_id') {
            programas[index] = { ...programas[index], programa_id: event.value, programa_nome: event.label };
        } else {
            const { name, value } = event.target;
            programas[index] = { ...programas[index], [name]: value };
        }
        this.setState({ programas });
    };

    //Operadores DA CARTEIRA
    carregarOperadoresCarteira = () => {
        if (this.state.carteira_id) {
            api.get(`/pessoas/operadores/carteiras/?carteira_id=${this.state.carteira_id}`)
                .then(response => {
                    const operadoresCarregados = response.data.results.map(operador => ({
                        id: operador.id,
                        operador_id: operador.operador_id,
                        operador_nome: operador.dados_operador.nome
                    }));
                    this.setState({ operadores: operadoresCarregados });
                })
                .catch(error => {
                    console.error('Erro ao carregar operadores:', error);
                    
                    let erro_msg = 'Erro ao carregar operadores da carteira, tente novamente';

                    if(error.response && error.response.status === 500){
                        erro_msg = 'Servidor indisponível no momento, tente novamente';
                    }

                    this.setState({
                        erroLoadRegistro: erro_msg,
                    })
                });
        }
    };

    salvarOperador = (index) => {
        const operador = this.state.operadores[index];
        const url = '/pessoas/operadores/carteiras/';
        const metodo = 'post';
    
        const dadosOperador = {
            carteira_id: this.state.carteira_id,
            operador_id: operador.operador_id
        };

        api({
            method: metodo,
            url: url,
            data: dadosOperador,
        })
        .then(response => {
            // Se for um novo operador, atualize o estado com a ID retornada pela API
            if (!operador.id) {
                this.setState(prevState => {
                    const operadoresAtualizados = [...prevState.operadores];
                    operadoresAtualizados[index].id = response.data.id;
                    return { operadores: operadoresAtualizados };
                });
            }
            
            const MySwal = withReactContent(Swal)
            const textSwal = (operador.id) ? 'Operador atualizado com sucesso' : 'Operador cadastrado com sucesso';

            MySwal.fire({
                title: <p>{textSwal}</p>,
                icon: 'success',
                showCloseButton: true,
            })
            
        })
        .catch(error => {
            let erro_msg = 'Erro ao cadastrar o operador, verifique os campos e tente novamente';   
            let content = '';         

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response && error.response.status === 400){
                const campos = error.response.data;                
                
                //percorre os campos com erro
                for (let key in campos){
                    var value = campos[key];

                    if(key == 'operador_id') {
                        content += `<br>&bull; Operador: ${value}`;
                    }
                };
            }

            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>{erro_msg}</p>,
                html: content,
            })
        });
    };

    adicionarOperador = () => {
        this.setState(prevState => ({
            operadores: [...prevState.operadores, { operador_id: '', operador_nome: '' }],
        }));
    };

    removerOperador = (index) => {
        const MySwal = withReactContent(Swal);
    
        MySwal.fire({
            title: 'Remover operador?',
            text: "Tem certeza que deseja remover este operador?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, remover!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {

                const operador = this.state.operadores[index];

                if (operador.id) {

                    const url = `/pessoas/operadores/carteiras/${operador.id}/`;
                    const metodo = 'delete';
                
                    api({
                        method: metodo,
                        url: url,
                    })
                    .then(response => {
                                              
                        const MySwal = withReactContent(Swal)
                        const textSwal = 'Operador removido com sucesso';

                        MySwal.fire({
                            title: <p>{textSwal}</p>,
                            icon: 'success',
                            showCloseButton: true,
                        })

                        this.setState(prevState => ({
                            operadores: prevState.operadores.filter((_, i) => i !== index),
                        }));
                        
                    })
                    .catch(error => {
                        let erro_msg = 'Erro ao remover o operador, tente novamente';            

                        if(error.response && error.response.status === 500){
                            erro_msg = 'Servidor indisponível no momento';
                        }
                        else if(error.response && error.response.status === 400){
                            const campos = error.response.data;       
                            
                        }

                        const MySwal = withReactContent(Swal)
                        MySwal.fire({
                            icon: 'error',
                            showCloseButton: true,
                            title: <p>{erro_msg}</p>,
                        })
                    });

                } else {
                    this.setState(prevState => ({
                        operadores: prevState.operadores.filter((_, i) => i !== index),
                    }));
        
                    MySwal.fire(
                        'Removido!',
                        'O operador foi removido.',
                        'success'
                    );
                }
            }
        });
    };

    handleOperadorChange = (index, event, fieldName) => {
        const operadores = [...this.state.operadores];
        if (fieldName === 'operador_id') {
            operadores[index] = { ...operadores[index], operador_id: event.value, operador_nome: event.label };
        } else {
            const { name, value } = event.target;
            operadores[index] = { ...operadores[index], [name]: value };
        }
        this.setState({ operadores });
    };

    //GESTORES DA CARTEIRA

    render(){
        return (
            <div>
                <Row className="align-items-center">
                    <Col sm={6} lg={6}>
                        <h4 className="page-title">{this.state.titulo_pagina}</h4>
                    </Col>
                </Row>
                <Tabs defaultActiveKey="dadosCarteira" id="tabs-carteira" className="aditus-tabs">
                    <Tab eventKey="dadosCarteira" title="Dados da Carteira">
                        <Card className="cardDestaque">
                            <Card.Body>                    
                                <Form onSubmit={this.enviaRegistro}>
                                    <h4>Dados da Carteira</h4>
                                    <Row>
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Nome da Carteira</Form.Label>
                                                <Form.Control type="text" name="nome" required placeholder="Nome da Carteira" value={this.state.nome} onChange={this.handleChange} />    
                                                <Form.Text id="formNomeHelpBlock" className="text-danger">{this.state.nomeHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    {this.state.erroLoadRegistro ? 
                                    <Alert variant="warning">
                                        {this.state.erroLoadRegistro}
                                    </Alert> : ''
                                    } 
                                    <Button variant="success" type="submit" className="btn-submit mt-3" disabled={this.state.loading}>
                                        {this.state.loading ? (
                                            <span className="spinner-border spinner-border-sm"></span>
                                        ) : (
                                            <>
                                                <FaCheck className="me-1" /> Salvar
                                            </>
                                        )}
                                    </Button>
                                </Form> 
                            </Card.Body>                
                        </Card>
                    </Tab>
                    {this.state.carteira_id && (
                        <Tab eventKey="programasCarteira" title="Programas">
                            <Card className="cardDestaque">
                                <Card.Body>                    
                                    <Form onSubmit={this.enviaProgramasCarteira}>
                                        <h4>Programas da Carteira</h4>
                                        {this.state.programas.map((programa, index) => (
                                            <div key={index} className="row-list">
                                                <Row>
                                                    <Col sm={6}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Programa</Form.Label>
                                                            <AsyncSelect
                                                                cacheOptions
                                                                loadOptions={this.carregarProgramas}
                                                                defaultOptions
                                                                name="programa_id"
                                                                placeholder="Buscar programa..."
                                                                noOptionsMessage={() => "Nenhum programa encontrado"}
                                                                onChange={e => this.handleProgramaChange(index, e, 'programa_id')}
                                                                value={programa.programa_id ? { value: programa.programa_id, label: programa.programa_nome } : null}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                                <Button variant="success" className="btn-sm" onClick={() => this.salvarPrograma(index)}><FaCheck className="me-1" /> Salvar Programa</Button>&nbsp;&nbsp;
                                                <Button variant="danger" className="btn-sm ml-3" onClick={() => this.removerPrograma(index)}><FaTimes className="me-1" /> Remover Programa</Button>
                                            </div>
                                        ))}
                                        <Button variant="secondary" onClick={this.adicionarPrograma}><FaStream /> Adicionar Programa</Button>
                                    </Form> 
                                </Card.Body>                
                            </Card>
                        </Tab>
                    )}
                    {this.state.carteira_id && (
                        <Tab eventKey="operadoresCarteira" title="Operadores">
                            <Card className="cardDestaque">
                                <Card.Body>                    
                                    <Form onSubmit={this.enviaGestoresCarteira}>
                                        <h4>Operadores da Carteira</h4>
                                        {this.state.operadores.map((operador, index) => (
                                            <div key={index} className="row-list">
                                                <Row>
                                                    <Col sm={6}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Operador</Form.Label>
                                                            <AsyncSelect
                                                                cacheOptions
                                                                loadOptions={this.carregarOperadores}
                                                                defaultOptions
                                                                name="operador_id"
                                                                placeholder="Buscar operador..."
                                                                noOptionsMessage={() => "Nenhum operador encontrado"}
                                                                onChange={e => this.handleOperadorChange(index, e, 'operador_id')}
                                                                value={operador.operador_id ? { value: operador.operador_id, label: operador.operador_nome } : null}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                                <Button variant="success" className="btn-sm" onClick={() => this.salvarOperador(index)}><FaCheck className="me-1" /> Salvar Operador</Button>&nbsp;&nbsp;
                                                <Button variant="danger" className="btn-sm ml-3" onClick={() => this.removerOperador(index)}><FaTimes className="me-1" /> Remover Operador</Button>
                                            </div>
                                        ))}
                                        <Button variant="secondary" onClick={this.adicionarOperador}><FaStream /> Adicionar Operador</Button>
                                    </Form> 
                                </Card.Body>                
                            </Card>
                        </Tab>
                    )}
                </Tabs>
            </div>
        )
    }
}

export default withRouter(CarteirasEdit);